import { render, staticRenderFns } from "./RequestViewGlobal.vue?vue&type=template&id=89586e50"
import script from "./RequestViewGlobal.vue?vue&type=script&lang=js"
export * from "./RequestViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports